import type { DataSourceAbstract, DevicePreviewEnum, FieldInputADTValue } from '@lighthouse/core'
import type { FieldInputError, SubFormErrors } from '@lighthouse/shared'
import {
    type CascadeParam,
    type CheckBoxParam,
    DEFAULT_LANG,
    type PersonParam,
    type PhoneNumberParam,
    type RelativeFieldParam,
    type UseUploadFileSParameter,
    zhCN
} from '@lighthouse/shared'
import type { UploadyProps } from '@rpldy/uploady'
import type { FC, PropsWithChildren } from 'react'
import React, { createContext, useContext } from 'react'

export interface SubFormFieldInputContextType
    extends RelativeFieldParam,
        CascadeParam,
        Pick<PhoneNumberParam, 'onFetchSmsCode'>,
        PersonParam,
        CheckBoxParam {
    blockId: string
    scope?: string
    viewRecordId?: string
    dataSourceInfo?: DataSourceAbstract
    language: string
    dataSource?: DataSourceAbstract
    isValid: boolean
    errors?: SubFormErrors
    columnsWidth?: Record<string, number>
    uploadyOptions?: Pick<UseUploadFileSParameter, 'info' | 'options'>
    fileMaxUploadSizeBytes?: number
    richTextUploadOptions?: UploadyProps
    submitAttempted?: boolean
    onCellChange?: (recordId: string, columnId: string, fieldValue: FieldInputADTValue) => void
    onRecordCopy?: (id: string) => void
    onRecordRemove?: (id: string) => void
    onChangeSmsCode?: (recordId: string, columnId: string, code: string) => void
    onChangeColumnWidth?: (id: string, width: number, isFinished: boolean) => void
    onCellBlur?: (recordId: string, columnId: string) => void
    reportCellError?: (recordId: string, columnId: string, error: FieldInputError | undefined) => void
    resetCellServiceError?: (recordId: string, columnId: string) => void
}

const SubFormFieldInputContext = createContext<SubFormFieldInputContextType>({
    blockId: '',
    language: DEFAULT_LANG,
    isValid: false
})

type SubFormFieldInputProviderProps = PropsWithChildren<{
    value: SubFormFieldInputContextType
}>

export const SubFormFieldInputProvider: FC<SubFormFieldInputProviderProps> = props => <SubFormFieldInputContext.Provider {...props} />

export const useSubFormFieldInputContext = () => useContext(SubFormFieldInputContext)
